import { render, staticRenderFns } from "./clearfix.vue?vue&type=template&id=db7c8b0c"
import script from "./clearfix.vue?vue&type=script&lang=js"
export * from "./clearfix.vue?vue&type=script&lang=js"
import style0 from "./clearfix.vue?vue&type=style&index=0&id=db7c8b0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports